module.exports = __webpack_public_path__ + "static/media/microsoft-365.77b31e5a.svg";